import { ISiteInfo, ISiteInfoLocation } from "../src/taskpane/interfaces/ISiteInfo";

export class SharePointSiteHelper {
    public static hubSites: ISiteInfo[] = [];

    static reset(): void {
        this.hubSites = [];
    }

    static groupAndSortSites(sites: ISiteInfoLocation[]): ISiteInfoLocation[] {
        if (Array.isArray(sites)) {
            const hubSites = sites
                .filter(site => site.isHub)
                .sort(this.sortSites);

            return hubSites
                .concat(sites
                    .filter(site => !site.isHub)
                    .sort(this.sortSites));
        }
        return [];
    }

    static sortSites(siteA: ISiteInfo, siteB: ISiteInfo): number {
        return siteA.name?.toUpperCase() < siteB.name?.toUpperCase() ? -1 : 1;
    }
}